import { render, staticRenderFns } from "./PdpV2.vue?vue&type=template&id=68060b0e&scoped=true"
import script from "./PdpV2.vue?vue&type=script&lang=js"
export * from "./PdpV2.vue?vue&type=script&lang=js"
import style0 from "./PdpV2.vue?vue&type=style&index=0&id=68060b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68060b0e",
  null
  
)

export default component.exports